import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    .loading-container {
        display: flex;
        flex-direction: column;
        gap: 1em;
        width: 100%;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .loading-spinner {
        font-size: 8em;
        --indicator-color: var(--ds-accent-color);
        --track-width: 15px;
    }

    .loading-text {
        width: 100%;
        font-size: 1.8em;
        text-align: center;
    }
`;
